import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RegresoViajePage } from './regreso-viaje';

@NgModule({
  declarations: [
    RegresoViajePage,
  ],
  imports: [
    IonicPageModule.forChild(RegresoViajePage),
  ],
  exports: [RegresoViajePage],
  entryComponents: [RegresoViajePage]
})
export class RegresoViajePageModule {}



// WEBPACK FOOTER //
// ./src/pages/regreso-viaje/regreso-viaje.module.ts